import { PublishersTable } from './components/PublishersTable/PublishersTable';

export function PublishersPage() {
  return (
    <main className="page-gutter min-w-0 py-6">
      <PublishersTable />
    </main>
  );
}
